import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import OrgAuthShell from "./OrgAuthShell";

const API = "https://api.komorotel.com/api";

/* Lien « ce n'est pas moi » du mail d'ajout. Rien à saisir : le jeton suffit.
   Demander une action de plus à quelqu'un qui signale une erreur, c'est la
   bonne façon de ne jamais le voir cliquer. */
export default function OrganizationDecline() {
  const { token } = useParams();
  const [etat, setEtat]       = useState("chargement");
  const [message, setMessage] = useState("");

  useEffect(() => {
    axios.get(`${API}/organization/membership/decline/${token}`)
      .then(r => { setEtat("ok"); setMessage(r.data.message); })
      .catch(err => {
        setEtat("erreur");
        setMessage(err.response?.data?.message || "Ce lien n'est plus valable.");
      });
  }, [token]);

  if (etat === "chargement") {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: "#fff" }}>
        <div
          className="w-8 h-8 rounded-full animate-spin"
          style={{ border: "3px solid #e5e7eb", borderTopColor: "var(--k-green)" }}
        />
      </div>
    );
  }

  return (
    <OrgAuthShell
      titre={etat === "ok" ? "C'est fait" : "Lien inutilisable"}
      sousTitre={message}
      pied={
        <>
          {etat === "ok" && "Cette organisation ne pourra plus réserver de séjour à votre nom. "}
          <a href="/" className="font-semibold text-[var(--k-green)] hover:underline">
            Retour à Komorotel
          </a>
        </>
      }
    >
      <span />
    </OrgAuthShell>
  );
}
